
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/mileages",
      function () {
        return require("private-next-pages/mypage/mileages/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/mileages"])
      });
    }
  